import { Grid, useMediaQuery } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getSubLabel } from 'lib/util/string'
import Text from 'ui/Element/Text'
import { notRegisteredLabel } from 'ui/Element/List/Item/Cell/ServiceItem/InstalledAtOrNotRegistered'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'

const styles = () => ({
  row: {
    gap: '0.75rem',
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: '0.25rem',
    alignItems: 'center',
  },
})

/**
 * Displays information about a service item.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellServiceItemInformation = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const {
    name = '-',
    serialLabel,
    serial,
    serialDistinction,
    installedAt: {
      value: {
        name: locationName,
        address,
      } = {},
    } = {},
  } = props
  const serialValue = serialDistinction ?? serial ?? '-'

  const isXs = useMediaQuery(t => t.breakpoints.down('sm'))
  const addressSummary = intl.address(isXs ? { city: address?.city } : address, { inline: true })
  const notRegistered = notRegisteredLabel().toUpperCase()

  const subStringContent = !props.installedAt
    ? [serialValue, notRegistered]
    : [serialValue, addressSummary]

  const subLabel = getSubLabel(
    Text,
    subStringContent,
    '•',
    (x, i, arr) => (i === arr.length - 1 && x === notRegistered
      ? {
        color: 'error',
        variant: '14/bold',
      }
      : {}),
  )

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={name}
            variant={'14/bold'}
            color={'black.main'}
          />
          <Grid
            item
            container
            xs={'auto'}
            className={classes.subLabel}
          >
            {subLabel}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellServiceItemInformation, styles)
